import { X } from 'lucide-react';

const TierRow = ({
  tier,
  index,
  onUpdate,
  onRemove,
  productMrp,
  baseSellingPrice,
  allTiers,
  canRemove = true,
  disableDiscount = false,
  hideUnit = false,
  unit,
}) => {
  const handleTierChange = (e) => {
    const { name, value } = e.target;
    let updatedTier = { ...tier, [name]: value };

    const minQuantity = parseInt(updatedTier.minQuantity, 10);
    const price = parseFloat(updatedTier.price);
    const mrp = parseFloat(productMrp);

    if (!isNaN(minQuantity) && minQuantity > 0 && !isNaN(price) && price > 0 && mrp > 0) {
      if (price > mrp) {
        updatedTier.discountPercentage = '0.00';
      } else {
        const discount = (((mrp - price) / mrp) * 100).toFixed(2);
        updatedTier.discountPercentage = discount;
      }
    } else {
      updatedTier.discountPercentage = '0.00';
    }

    onUpdate(index, updatedTier);
  };

  return (
    <tr className="border-t">
      <td className="px-4 py-2">
        <input
          name="minQuantity"
          type="number"
          value={tier.minQuantity}
          onChange={handleTierChange}
          placeholder="e.g., 50"
          className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
        />
      </td>
      {!hideUnit && (
        <td className="px-4 py-2 min-w-[110px]">
          <input
            type="text"
            value={unit}
            readOnly
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm bg-gray-100 cursor-not-allowed"
          />
        </td>
      )}
      <td className="px-4 py-2">
        <input
          name="price"
          type="number"
          value={tier.price}
          onChange={handleTierChange}
          placeholder="e.g., 90.00"
          className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
        />
      </td>
      <td className="px-4 py-2">
        <input
          type="text"
          value={tier.discountPercentage || '0.00'}
          readOnly
          className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm bg-gray-100 cursor-not-allowed"
        />
      </td>
      <td className="px-4 py-2 text-center">
        {canRemove && (
          <button
            type="button"
            onClick={() => onRemove(index)}
            className="text-red-500 hover:text-red-700"
          >
            <X size={18} />
          </button>
        )}
      </td>
    </tr>
  );
};

export default TierRow;
